export const downloadFile = (data: Blob, filename: string) => {
    const url = window.URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    setTimeout(() => a.click(), 100);
    setTimeout(() => {
        URL.revokeObjectURL(url);
        a.remove();
    }, 60 * 1000);
};
